import {ProductPackagesModalConfig} from "../types/product-packages-modal.types";
import {ProductPackagesModalComponent} from "../components/product-packages-modal/product-packages-modal.component";
import {
  UploadPackagesExcelModalComponent
} from "../components/upload-packages-excel-modal/upload-packages-excel-modal.component";
import {
  DownloadPackagesExcelModalComponent
} from "../components/download-packages-excel-modal/download-packages-excel-modal.component";

const fields = [
  'noPackageModalDto',
  'singleItemPackageModalDto',
  'transportBoxModalDto',
  'palletModalDto',
  'truck33PalletsModalDto',
  'gazelle6PalletsModalDto',
  'gazelle10PalletsModalDto'
];

export const productPackagesModalConfig: Record<string, ProductPackagesModalConfig> = {};

fields.forEach(fieldName => {
  productPackagesModalConfig[fieldName] = {
    component: ProductPackagesModalComponent,
    fieldName,
    width: '550px'
  };
});

productPackagesModalConfig['uploadProductPackagesExcel'] = {
  component: UploadPackagesExcelModalComponent,
  fieldName: 'uploadProductPackagesExcel',
  width: '550px'
};

productPackagesModalConfig['downloadProductPackagesExcel'] = {
  component: DownloadPackagesExcelModalComponent,
  fieldName: 'downloadProductPackagesExcel',
  width: '550px'
}
